import {
  APP_ROUTES_CONSTANTS,
  LAYOUT_ROUTE
} from './../../../../constants/routes.constants';
import {
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';

import { PROFILE_SETUP_ROUTE } from './../../../accounts/constants/routes.constants';
import {
  Router
} from '@angular/router';
import { TokenService } from 'src/app/services/token/token.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'aog-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {

  contentManagementRoute = APP_ROUTES_CONSTANTS;
  socialLinks = environment.socialLinks;
  date = new Date().getFullYear();
  constructor(
    public $token: TokenService,
    private $router: Router) { }

  ngOnInit() {
  }

  navigateHandle() {
    if (this.$router.url === '/') {
      this.$router.navigate([''], { fragment: 'aog_header' });
      // return;
    }
    else if (this.$router.url === '/account/profile-setup') {
      this.$router.navigate([PROFILE_SETUP_ROUTE.url], { fragment: 'aog_profile_setup' });
      // return;
    }
    else if (this.$router.url === '/account/login' || this.$router.url === '/account/signup') {
      const url: string = this.$router.url.endsWith('/login') ? '/account/login' : '/account/signup'
      const fragmet = url.includes('/login') ? 'aog_login' : 'aog_signup'
      this.$router.navigate([url], { fragment: fragmet })
      // return;
    } else if (this.$router.url === '/dashboard') {
      this.$router.navigate([LAYOUT_ROUTE.url], { fragment: 'aog_dashboard' })
      // return;
    }
    else if (this.$router.url === '/dashboard/home') {
      this.$router.navigate([LAYOUT_ROUTE.url], { fragment: 'aog_dashboard' })
    }

    // else

  }

  // [routerLink] = "['/']" fragment = "aog_header"



}
